import { createRoutine } from 'redux-saga-routines';

export const fetchFilteredViews = createRoutine('FETCH_FILTERED_VIEWS');
export const fetchFilteredViewsByType = createRoutine(
  'FETCH_FILTERED_VIEWS_BY_TYPE'
);
export const selectFilteredView = createRoutine('SELECT_FILTERED_VIEW');
export const createFilteredView = createRoutine('CREATE_FILTERED_VIEW');
export const editFilteredView = createRoutine('EDIT_FILTERED_VIEW');
export const deleteFilteredView = createRoutine('DELETE_FILTERED_VIEW');
export const clearFilteredView = createRoutine('CLEAR_FILTERED_VIEW');
